module.exports = __webpack_public_path__ + "img/tablet.b245ce6e.jpg";